import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod"
import { endpoint } from "../../common/constant"
import { fetchAllPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod"
import { BULK_TYPE, CONFIG_TYPE } from "./constant"
import { templateUrl } from "../../common/constant/endpoints/documentService"
export const getDropdowns = async () => {

    const p = await Promise.all([
        dropdownMapping(endpoint.businessArea.getAllActiveV2, "businessAreaDispValue", 'businessAreaDispValue'),
        dropdownMapping(endpoint.courseCategory.getAllActiveCourseCategory, "courseAttributeValueDispValue", 'courseAttributeValueDispValue'),
        dropdownMapping(endpoint.term.getAllActive, "termDispValue", 'termDispValue'),
        dropdownMapping(endpoint.academic_group.getAllActive, "academicGroupDispValue", 'academicGroupDispValue'),
        dropdownMapping(endpoint.academic_career.getAllActive, "academicCareerDispValue", 'academicCareerDispValue'),
    ])

    return {
        businessArea: p[0],
        courseCategory: p[1],
        term: p[2],
        academicGroup: p[3],
        academicCareer: p[4],
    }
}

export const getAuditDetail = async(id)=>{
   return await fetchAllPromisedData(`${endpoint.concessionConfigArpu.getAuditLogs}/${id}${CONFIG_TYPE}`)
}

export const getAllActiveProcessTag=async(process_Tag)=>{
    try{
   const res= await fetchAllPromisedData(endpoint.process_Tag.getAllActive)
    return res.find((item) => {
        if (item?.tagTypeKey == process_Tag) {
            return item;
        }

    })
    }
    catch(err){
        console.error(err);
    }
}
export const getDownloadTemplateUrl = async (TEMPLATE_NAME) => {

    return await fetchAllPromisedData(`${templateUrl}?documentTypeDisplayValue=${TEMPLATE_NAME}&serviceType=${TEMPLATE_NAME}`)
}

export const getBulkLogsAudit = async({page,pageSize})=>{
    return await fetchAllPromisedData(`${endpoint.bulkUpload.arpu}?type=${BULK_TYPE}&offset=${page}&pageSize=${pageSize}`)
}
